/**
 * Stable CSS class names for E2E — pages/SiteManagement/ListUserRoles.
 * Containers use `list-user-roles__<element>`; inputs and user-interactable
 * controls use `list-user-roles-input--<name>`.
 */
export const LUR = {
    page: 'list-user-roles-page',
    root: 'list-user-roles',

    /* --- Drawers ------------------------------------------------------- */
    detailDrawer: 'list-user-roles__detail-drawer',
    updateDrawer: 'list-user-roles__update-drawer',

    /* --- Popover ------------------------------------------------------- */
    rolesPopover: 'list-user-roles__roles-popover',
    rolesPopoverChip: 'list-user-roles__roles-popover-chip',
    rolesPopoverEmptyChip: 'list-user-roles__roles-popover-empty-chip',

    /* --- Header / search ---------------------------------------------- */
    breadcrumb: 'list-user-roles__breadcrumb',
    searchPaper: 'list-user-roles__search-paper',
    inputSearch: 'list-user-roles-input--search',
    btnSearch: 'list-user-roles-input--button-search',

    /* --- Loading / table --------------------------------------------- */
    loading: 'list-user-roles__loading',
    tableContainer: 'list-user-roles__table-container',
    table: 'list-user-roles__table',
    tableHead: 'list-user-roles__table-head',
    tableHeadRow: 'list-user-roles__table-head-row',
    tableHeadCell: 'list-user-roles__table-head-cell',
    tableHeadCellUserName: 'list-user-roles__table-head-cell--user-name',
    tableHeadCellOperatorId: 'list-user-roles__table-head-cell--operator-id',
    tableHeadCellActive: 'list-user-roles__table-head-cell--active',
    tableHeadCellStoreCode: 'list-user-roles__table-head-cell--store-code',
    tableHeadCellIsStoreEmployee: 'list-user-roles__table-head-cell--is-store-employee',
    tableHeadCellDetail: 'list-user-roles__table-head-cell--detail',
    tableHeadCellEdit: 'list-user-roles__table-head-cell--edit',
    tableBody: 'list-user-roles__table-body',
    tableBodyRow: 'list-user-roles__table-body-row',
    cellUserName: 'list-user-roles__cell-user-name',
    cellOperatorId: 'list-user-roles__cell-operator-id',
    cellActive: 'list-user-roles__cell-active',
    inputCellActiveSwitch: 'list-user-roles-input--cell-active-switch',
    cellStoreCode: 'list-user-roles__cell-store-code',
    cellIsStoreEmployee: 'list-user-roles__cell-is-store-employee',
    cellIsStoreEmployeeYes: 'list-user-roles__cell-is-store-employee--yes',
    cellIsStoreEmployeeNo: 'list-user-roles__cell-is-store-employee--no',
    cellDetail: 'list-user-roles__cell-detail',
    btnDetail: 'list-user-roles-input--button-detail',
    cellEdit: 'list-user-roles__cell-edit',
    btnEdit: 'list-user-roles-input--button-edit',

    /* --- Empty state -------------------------------------------------- */
    emptyState: 'list-user-roles__empty-state',

    /* ------------------------------------------------------------------ */
    /* Detail drawer (ListUserDetailComponent)                            */
    /* ------------------------------------------------------------------ */
    detailRoot: 'list-user-roles-detail',
    detailHeaderBox: 'list-user-roles-detail__header-box',

    /* Sub-dialogs */
    detailDialogTransfer: 'list-user-roles-detail__dialog-transfer',
    detailDialogTransferTitle: 'list-user-roles-detail__dialog-transfer-title',
    detailDialogRoleGroup: 'list-user-roles-detail__dialog-role-group',
    detailDialogRoleGroupTitle: 'list-user-roles-detail__dialog-role-group-title',

    /* Action table */
    detailTable: 'list-user-roles-detail__table',
    detailTableBody: 'list-user-roles-detail__table-body',
    detailRow: 'list-user-roles-detail__row',
    detailRowSpacer: 'list-user-roles-detail__row-spacer',
    detailRowHarmony: 'list-user-roles-detail__row--harmony',
    detailRowOperatorId: 'list-user-roles-detail__row--operator-id',
    detailRowTransfer: 'list-user-roles-detail__row--transfer',
    detailRowRoleGroup: 'list-user-roles-detail__row--role-group',
    detailRowStoreCode: 'list-user-roles-detail__row--store-code',
    detailRowEmail: 'list-user-roles-detail__row--email',
    detailRowOperatorIdInfo: 'list-user-roles-detail__row--operator-id-info',
    detailRowUserRef: 'list-user-roles-detail__row--user-ref',
    detailRowHrref: 'list-user-roles-detail__row--hrref',
    detailRowDomain: 'list-user-roles-detail__row--domain',
    detailRowHarmonySyncDate: 'list-user-roles-detail__row--harmony-sync-date',
    detailRowCreateDate: 'list-user-roles-detail__row--create-date',
    detailRowUpdateDate: 'list-user-roles-detail__row--update-date',
    detailRowIsStoreEmployee: 'list-user-roles-detail__row--is-store-employee',
    detailRowRole: 'list-user-roles-detail__row--role',
    detailCellLabel: 'list-user-roles-detail__cell-label',
    detailCellValue: 'list-user-roles-detail__cell-value',

    btnDetailHarmony: 'list-user-roles-input--button-detail-harmony',
    btnDetailOperatorId: 'list-user-roles-input--button-detail-operator-id',
    btnDetailTransfer: 'list-user-roles-input--button-detail-transfer',
    btnDetailRoleGroupAdd: 'list-user-roles-input--button-detail-role-group-add',

    detailRoleBox: 'list-user-roles-detail__role-box',
    detailRoleName: 'list-user-roles-detail__role-name',
    btnDetailRoleDelete: 'list-user-roles-input--button-detail-role-delete',
    detailActionsSection: 'list-user-roles-detail__actions-section',
    detailActionCard: 'list-user-roles-detail__action-card',
    detailInfoPaper: 'list-user-roles-detail__info-paper',
    detailInfoRow: 'list-user-roles-detail__info-row',
    detailRolesSection: 'list-user-roles-detail__roles-section',
    inputDetailRoleFilter: 'list-user-roles-input--detail-role-filter',
    detailRoleChip: 'list-user-roles-detail__role-chip',

    /* Accordion sections */
    detailAccordion: 'list-user-roles-detail__accordion',
    detailAccordionEdit: 'list-user-roles-detail__accordion--edit',
    detailAccordionActions: 'list-user-roles-detail__accordion--actions',
    detailAccordionInfo: 'list-user-roles-detail__accordion--info',
    detailAccordionRoles: 'list-user-roles-detail__accordion--roles',

    /* ------------------------------------------------------------------ */
    /* Update form (UpdateUserInfoComponent)                              */
    /* ------------------------------------------------------------------ */
    updateRoot: 'list-user-roles-update',
    updateHeaderBox: 'list-user-roles-update__header-box',
    updateFieldEmail: 'list-user-roles-update__field-email',
    updateFieldStoreCode: 'list-user-roles-update__field-store-code',
    updateFieldOperatorId: 'list-user-roles-update__field-operator-id',
    updateFieldActive: 'list-user-roles-update__field-active',
    updateActions: 'list-user-roles-update__actions',
    updateFormPaper: 'list-user-roles-update__form-paper',
    inputUpdateEmail: 'list-user-roles-input--update-email',
    inputUpdateStoreCode: 'list-user-roles-input--update-store-code',
    inputUpdateOperatorId: 'list-user-roles-input--update-operator-id',
    inputUpdateActive: 'list-user-roles-input--update-active',
    btnUpdateSubmit: 'list-user-roles-input--button-update-submit',

    /* ------------------------------------------------------------------ */
    /* Select operator modal                                              */
    /* ------------------------------------------------------------------ */
    selectModal: 'list-user-roles-select-operator',
    selectModalTitle: 'list-user-roles-select-operator__title',
    selectModalSelectedList: 'list-user-roles-select-operator__selected-list',
    selectModalSelectedItem: 'list-user-roles-select-operator__selected-item',
    selectModalSelectedChip: 'list-user-roles-select-operator__selected-chip',
    selectModalUserItem: 'list-user-roles-select-operator__user-item',
    selectModalActions: 'list-user-roles-select-operator__actions',
    btnSelectClear: 'list-user-roles-input--button-select-clear',
    btnSelectTransfer: 'list-user-roles-input--button-select-transfer',
    inputSelectSearch: 'list-user-roles-input--select-search',
    selectModalTable: 'list-user-roles-select-operator__table',
    selectModalRow: 'list-user-roles-select-operator__row',
    btnSelectAddOperator: 'list-user-roles-input--button-select-add-operator',

    /* ------------------------------------------------------------------ */
    /* Role modal                                                         */
    /* ------------------------------------------------------------------ */
    roleModal: 'list-user-roles-role-modal',
    roleModalFilter: 'list-user-roles-role-modal__filter',
    inputRoleModalFilter: 'list-user-roles-input--role-modal-filter',
    roleModalGrid: 'list-user-roles-role-modal__grid',
    cellRoleId: 'list-user-roles-role-modal__cell-role-id',
    cellRoleName: 'list-user-roles-role-modal__cell-role-name',
    cellRoleAction: 'list-user-roles-role-modal__cell-role-action',
    btnRoleAdd: 'list-user-roles-input--button-role-add',
} as const;

export const lurCls = (...parts: Array<string | undefined | false>) => parts.filter(Boolean).join(' ');
